const MutualHelp = () =>
  import(
    /* webpackChunkName: "mutualHelp~index" */ 'page/platform/mutualHelp/index.vue'
  )
const bookClub = () =>
  import(
    /* webpackChunkName: "mutualHelp~index" */ 'page/platform/mutualHelp/bookClub.vue'
  )

let routes = [
  {
    path: '/mutualHelp/index',
    component: MutualHelp,
    meta: {
      pageName: '互助首页',
      business: '平台',
      title: '互助首页'
    }
  },
  {
    path: '/mutualHelp/bookClub',
    component: bookClub,
    meta: {
      pageName: '书友伴读',
      business: '平台',
      title: '书友伴读'
    }
  }
]

export default routes
